<template>
    <div class="modal-ServiceEdit">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">客服编辑</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <el-form :model="editForm" :rules="rules" ref="editForm">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="姓名" required prop="name">
                                    <el-input v-model="editForm.name" placeholder="请输入姓名"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="手机号" required prop="phone">
                                    <el-input v-model="editForm.phone" placeholder="请输入手机号" maxlength="11"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="主叫800号码" required prop="callingPhone">
                                    <el-input v-model="editForm.callingPhone" placeholder="请输入主叫800号码"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="代理商" required prop="governmentCode">
                                    <el-select v-model="editForm.governmentCode" placeholder="请选择代理商" style="width:100%">
                                        <el-option
                                            v-for="item in governmentList"
                                            :key="item.governmentCode"
                                            :label="item.name"
                                            :value="item.governmentCode">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-form>
            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">编辑</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: 'Edit',
        props:['governmentList'],
        data() {
            return {
                loading: false,
                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    name:'',
                    phone:'',
                    seatsCode:'',
                    callingPhone:'',
                    governmentCode:''
                },
                rules:{
                    phone:[
                        { required: true, message: '请输入手机号', trigger: 'blur' },
                        {
                            pattern: /^1[3456789]\d{9}$/,
                            message: '请输入正确的手机号'
                        },
                    ],
                    name:[
                        { required: true, message: '请输入商家名称', trigger: 'blur' },
                    ],
                    callingPhone:[
                        { required: true, message: '请输入主叫号码', trigger: 'blur' },
                    ],
                    governmentCode:[
                        { required: true, message: '请选择政府', trigger: 'blur' },
                    ],
                },
            }
        },

        methods: {
            init(row){
                this.$refs.editForm.resetFields();
                this.editForm.name=row.name
                this.editForm.phone=row.phone
                this.editForm.seatsCode=row.seatsCode
                this.editForm.callingPhone=row.callingPhone
                this.editForm.governmentCode=row.governmentCode
            },
            closeSelf() {
                this.$emit("closeEdit");
            },
            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        this.editSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },
            editSubmit(){
                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }
                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Seats/Edit",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },


        }
    }


</script>





<style lang="scss" scoped>

    .modal-ServiceEdit {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 700px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                overflow-y:auto;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
